import { forwardRef, type FormEvent } from "react";
import Loader from "../loader";
interface Props {
    submitButtonText: string;
    submitAction: (e: FormEvent<HTMLFormElement>) => Promise<void>;
    children: React.ReactNode;
    noValidate?: boolean;
    loading?: boolean;
    customClass?: string;
}

const FormContainer = (props: Props, ref: any) => {
    const { submitAction, submitButtonText, customClass, loading } = props;

    return (
        <div className={`cmp-form-container position-relative ${customClass ?? ""}`} ref={ref}>
            {loading && <Loader />}
            <form
                method="POST"
                className="cmp-form"
                noValidate
                onSubmit={(e) => {
                    submitAction(e);
                }}
            >
                {props.children}
                <button
                    type="submit"
                    className="btn btn-primary px-3 font-weight-bold btn-lg mt-4"
                    disabled={!!loading}
                >
                    {submitButtonText || "Submit"}
                </button>
            </form>
        </div>
    );
};

export default forwardRef(FormContainer);
